<template>
  <div class="cart-payment">
    <p class="cart-title">{{ Translator('front.cart.payment.title')}}</p>
    <form class="std-form" @submit="onSubmit" ref="form">

      <div class="cart-free" v-if="cart.totalTtc === 0">
        <p class="cart-subtitle">{{ Translator('front.cart.payment.subtitle_free')}}</p>
        <p class="cart-description" v-html="Translator('front.cart.payment.description_free')"></p>
      </div>
      <div v-else>
        <p class="cart-subtitle">{{ Translator('front.cart.payment.subtitle')}}</p>
        <p class="cart-description" v-html="Translator('front.cart.payment.description')"></p>
        <p class="cart-error" v-if="errorMessage">{{ errorMessage }}</p>
        <div class="card-image-preview">
          <img src="/assets/default/images/card.svg" alt="">
        </div>
        <div class="form-group form-group-number">
          <div class="form-label-container">
            <label for="payment-number" class="control-label required">{{ Translator('front.cart.payment.card_number')}}</label>
          </div>
          <div class="card-input" ref="cardNumber"></div>
          <p class="form-error" v-if="errorcardNumber">{{ errorcardNumber }}</p>
        </div>
        <div class="form-row">
          <div class="form-group form-group-expiry">
            <div class="form-label-container">
              <label for="payment-expiration" class="control-label required">{{ Translator('front.cart.payment.card_expiration')}}</label>
            </div>
            <div class="card-input" ref="cardExpiry"></div>
            <p class="form-error" v-if="errorcardExpiry">{{ errorcardExpiry }}</p>
          </div>
          <div class="form-group form-group-cvc">
            <div class="form-label-container">
              <label for="payment-code" class="control-label required">{{ Translator('front.cart.payment.card_code')}}</label>
            </div>
            <div class="card-input" ref="cardCvc"></div>
            <p class="form-error" v-if="errorcardCvc">{{ errorcardCvc }}</p>
          </div>
        </div>
      </div>

      <div class="form-group checkbox" :class="{'is-error': errorCheckConditions && !terms}">
        <label>
          <input type="checkbox" v-model="terms">
          <span v-html="Translator('front.cart.payment.disclamer', {'conditions_link': linkCGV})" v-if="linkCGV"></span>
          <span v-html="Translator('front.cart.payment.disclamer_no_link')" v-else></span>
        </label>
      </div>
      <button type="submit">{{ Translator('front.cart.resume.buttons.step_4') }}</button>
    </form>
  </div>
</template>
<script>
import AppControlService from '@/services/AppControl';
import CardService from '@/services/Card';
import OrdersService from '@/services/Orders';
export default {
  name: 'cart-payment',
  data () {
    return {
      linkCGV: window.config && window.config.linkCGV ? window.config.linkCGV : null,
      currentPayment: null,
      errorcardNumber: null,
      errorcardExpiry: null,
      errorcardCvc: null,
      errorCheckConditions: false,
      errorMessage: null,
      cart: OrdersService.cart,
      terms: false,
      paymentMethods: [],
      form: {
        method: null,
        number: null,
        expiration: null,
        code: null
      }
    }
  },
  created() {
    this.onNextStep = this.onNextStep.bind(this);
    this._onCheckError = this._onCheckError.bind(this);
    AppControlService.on('validating', this.onNextStep);
  },
  beforeDestroy() {
    AppControlService.off('validating', this.onNextStep);
    if(this._card) {
      if (this._card.cardNumber) this._card.cardNumber.off('change', this._onCheckError);
      if (this._card.cardExpiry) this._card.cardExpiry.off('change', this._onCheckError);
      if (this._card.cardCvc) this._card.cardCvc.off('change', this._onCheckError);
      CardService.destroy();
      this._card = null;
    }
  },
  mounted() {
    this._getPaymentMethods();
  },
  methods: {
    onNextStep() {
      this.$refs.form.querySelector('button[type="submit"]').click();
    },

    onSubmit(pEvt) {
      pEvt.preventDefault();
      this.errorCheckConditions = !this.terms;
      if(!this.terms) {
        AppControlService.abortStep();
        return;
      }
      if(this._isSubmited) return;
      this._isSubmited = true;
      const expected = this._expected || OrdersService.expected();
      if(this.cart.totalTtc > 0) {
        CardService.checkPayment(this.currentPayment, expected).then( (res) => {
          if(!res.data?.valid) {
            this._onCartChanged(this._errorMessage({ response: res }));
            return;
          }
          OrdersService.confirm(expected).then( () => {
            CardService.payment(this._card.cardNumber).then( () => {
              AppControlService.goToNextStep();
            }).catch((err) => {
              console.error(err);
              // The PaymentIntent was cancelled server side (stale amount): nothing was charged
              if(err.error && err.error.code === 'payment_intent_unexpected_state') {
                this._onCartChanged();
                return;
              }
              this.errorMessage = this._errorMessage(err);
            }).then( () => {
              AppControlService.abortStep();
              this._isSubmited = false;
            });
          }).catch((err) => {
            console.error(err);
            if(err.response && err.response.status === 422) {
              this._onCartChanged(this._errorMessage(err));
              return;
            }
            this.errorMessage = this._errorMessage(err);
            AppControlService.abortStep();
            this._isSubmited = false;
          });
        }).catch((err) => {
          console.error(err);
          this._onCartChanged(this._errorMessage(err));
        })
      } else {
        OrdersService.confirm(expected).then( () => {
          CardService.paymentFree(OrdersService.cart).then( () => {
            AppControlService.goToNextStep();
          }).catch((err) => {
            console.error(err);
            this.errorMessage = this._errorMessage(err);
          }).then( () => {
            AppControlService.abortStep();
            this._isSubmited = false;
          });
        }).catch((err) => {
          console.error(err);
          if(err.response && err.response.status === 422) {
            this._onCartChanged(this._errorMessage(err));
            return;
          }
          this.errorMessage = this._errorMessage(err);
          AppControlService.abortStep();
          this._isSubmited = false;
        });
      }
    },

    // The cart no longer matches what was displayed: nothing has been charged. Reload it and send
    // the customer back to the first step, the message stays displayed by CartResume.
    _onCartChanged(message = null) {
      this.errorMessage = message || this.Translator('front.cart.payment.cart_changed');
      AppControlService.abortStep();
      OrdersService.get().catch(console.error).then(() => {
        OrdersService.notifyCartChanged(this.errorMessage);
        this._isSubmited = false;
        AppControlService.goTo(0);
      });
    },

    _errorMessage(err) {
      // Payment check refusals carry a reason code: translate it on our side, in the page locale
      const reason = err && err.response && err.response.data ? err.response.data.reason : null;
      if(reason === 'processing_type_unavailable') return this.Translator('front.cart.payment.processing_type_unavailable');
      if(reason) return this.Translator('front.cart.payment.cart_changed');
      if(err && err.response && err.response.data && err.response.data['hydra:description']) return err.response.data['hydra:description'];
      if(err && err.error && err.error.message) return err.error.message;
      if(err && err.response && err.response.data && err.response.data.message) return err.response.data.message;
      return this.Translator('front.cart.payment.cart_changed');
    },

    _onCheckError(pEvt) {
      this[`error${pEvt.elementType}`] = null;
      if (pEvt.error && pEvt.error.message) {
        this[`error${pEvt.elementType}`] = pEvt.error.message;
        AppControlService.abortStep();
      }
    },

    _getPaymentMethods() {
      CardService.getMethods().then( methods => {
        this.paymentMethods = methods;
        this.form.method = OrdersService.cart.cartPayment.method['@id'];
        this.currentPayment = OrdersService.cart.cartPayment;
        // Snapshot of what is displayed while the PaymentIntent is created for this payment
        this._expected = OrdersService.expected();
        this.paymentMethods.forEach(method => {
          if(this.form.method === method['@id']) this.currentMethod = method
        });
        this._checkPaymentMethod();
      })
    },

    _checkPaymentMethod() {
      if(this.currentMethod && this.currentMethod.code === 'cb-stripe') {
        this.stripeLoad = true;
        CardService.initStripe().then( res => {
          if(!this._card) {
            this._card = res;
            this.stripeLoad = false;
            setTimeout(() => {
              this._card.cardNumber.mount(this.$refs.cardNumber);
              this._card.cardExpiry.mount(this.$refs.cardExpiry);
              this._card.cardCvc.mount(this.$refs.cardCvc);
              this._card.cardNumber.on('change', this._onCheckError);
              this._card.cardExpiry.on('change', this._onCheckError);
              this._card.cardCvc.on('change', this._onCheckError);
            });
          }
        })
      }
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style scoped lang="scss">
.cart-payment {
  .cart-free {
    margin-bottom: rem(30);
  }
  .card-input {
    @include form-input;
    padding-top: 0;
    padding-bottom: 0;
    width: 100%;
    overflow: visible;
    iframe,
    div {
      height: 100% !important;
    }
  }
  .cart-error {
    @include form-error;
    @include visible;
    display: block;
    margin-top: 0;
    margin-bottom: rem(10);
  }
  .card-image-preview {
    position: absolute;
    top: rem(15);
    right: rem(20);
    img {
      width: rem(140);
    }
    @include mobile {
      display: none;
    }
  }
  .form-error {
    @include visible;
    display: block;
  }
  .form-group-number {
    @include tablet {
      width: rem(320);
    }
  }
  .form-group-expiry {
    @include tablet {
      width: rem(150);
    }
    flex: inherit !important;
  }
  .form-group-cvc {
    @include tablet {
      width: rem(150);
    }
    flex: inherit !important;
  }
  .cart-subtitle {
    font-weight: bold;
    font-size: rem(18);
    margin-bottom: rem(10);
    color: $black;
  }
  .cart-description {
    margin-bottom: rem(40);
  }
  .std-form {
    position: relative;
    margin-left: 0;
    margin-right: 0;
  }
  button[type="submit"] {
    display: none;
  }
}
</style>